export default __webpack_public_path__ + "static/og-myth-citzen-data-scientist-e72ce922cf7a075efcb41170648f27bb.jpg";